import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'
import { theme } from 'src/providers/ThemeProvider'

const DRAWER_WIDTH_OPEN = 250
const DRAWER_WIDTH_CLOSE = 56

export const styles = {
  popper: {
    sx: {
      maxWidth: '200px',

      '& .MuiTooltip-tooltip': {
        borderRadius: '4px',
        backgroundColor: theme.colors.blue08,
        color: theme.colors.gray14,
        fontFamily: theme.corporate.primaryFont,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '18px',
        padding: theme.spacing(1),
        boxShadow: '0px 1px 3px 0px rgba(113, 113, 113, 0.25)'
      },

      '& .MuiTooltip-arrow': {
        color: theme.colors.blue08
      }
    }
  }
}

export default makeStyles((theme: Theme) => ({
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    width: DRAWER_WIDTH_OPEN,
    position: 'relative',
    transition: 'width 0.2s ease-out',
    marginTop: 66,

    '& .MuiPaper-root': {
      width: '100%',
      backgroundColor: theme.colors.blue08,
      border: 'none',
      position: 'absolute',
      bottom: 0,
      overflow: 'hidden',
      overflowY: 'auto'
    },

    '& .hideElement': {
      width: DRAWER_WIDTH_OPEN - DRAWER_WIDTH_CLOSE
    }
  },

  closeDrawer: {
    width: DRAWER_WIDTH_CLOSE,
    overflow: 'hidden',

    '& .hideElement': {
      width: 0,
      opacity: 0
    },

    '& .MuiListItemButton-root': {
      paddingRight: 0
    },

    '& .collapseMenuItem': {
      justifyContent: 'center'
    }
  },

  list: {
    padding: 0,

    '@media (max-width: 600px)': {
      marginTop: '15px'
    }
  },

  listItem: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 14,
    paddingRight: theme.spacing(1.5),
    width: '100%',
    height: '44px',

    '& .MuiTypography-body1': {
      fontSize: 16,
      fontWeight: '400',
      marginLeft: theme.spacing(1.5),
      marginTop: '3px'
    },

    '&[data-selected=true]': {
      backgroundColor: theme.colors.blue07,

      '&:hover': {
        backgroundColor: theme.colors.blue06
      },

      '& .MuiTypography-body1': {
        fontWeight: '700'
      }
    },

    '&:hover': {
      backgroundColor: theme.colors.blue07
    }
  },

  listItemBadge: {
    backgroundColor: '#7F8CBB',
    borderRadius: '2px',
    fontFamily: theme.fonts.secondaryFont,
    fontSize: 10,
    fontWeight: 700,
    color: theme.corporate.secondaryColor,
    height: 14,
    marginLeft: theme.spacing(1),
    marginTop: '3px',

    '& .MuiChip-label': {
      padding: theme.spacing(0, 0.5)
    }
  },

  listItemIcon: {
    width: 20,
    height: 20,
    padding: theme.spacing(0.5),
    boxSizing: 'content-box',
    transition: 'transform 0.3s ease-out',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  listItemSelected: {
    flex: '0 0 auto',
    width: 4,
    marginRight: theme.spacing(1.5),
    height: '100%',

    '[data-selected=true] & ': {
      backgroundColor: '#cb2268'
    }
  },

  listItemSubList: {
    backgroundColor: theme.colors.white01
  },

  subListItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '44px',
    padding: theme.spacing(0, 1.5, 0, 3),

    '& .MuiTypography-root': {
      fontFamily: theme.fonts.primaryFont,
      fontSize: 16,
      color: theme.corporate.primaryColor
    },

    '&[aria-current=page]': {
      backgroundColor: theme.colors.blue07,

      '&:hover': {
        backgroundColor: theme.colors.blue06
      },

      '& .MuiTypography-body1': {
        fontWeight: '700'
      }
    },

    '&:hover': {
      backgroundColor: theme.colors.blue07
    }
  },

  toolbar: {
    ...theme.mixins.toolbar,
    minHeight: 76,
    '@media (min-width: 0px)': {
      minHeight: 76
    },
    '@media (min-width: 600px)': {
      minHeight: 76
    }
  },

  operativa: {
    color: theme.corporate.primaryColor,
    padding: theme.spacing(0, 0, 0, 0)
  },

  success: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.main
  },

  warning: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark
  },

  error: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark
  },

  lexnetAvisos: {
    color: theme.corporate.primaryColor,

    '& .MuiListItemText-root': {
      flex: '0 0 auto'
    },

    '&:hover': {
      backgroundColor: theme.colors.blue07
    }
  },

  avisosLink: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    marginLeft: '6px'
  },

  collapseMenu: {
    padding: theme.spacing(1, 1.5),
    color: theme.colors.white01
  },

  collapseMenuItem: {
    color: theme.corporate.primaryColor,
    height: 28,
    minWidth: 'unset',
    fontFamily: theme.corporate.primaryFont,
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'initial',
    lineHeight: '16px',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'flex-end',
    display: 'flex',
    width: '100%',
    margin: 0,
    padding: 0,

    '& span': {
      marginRight: theme.spacing(1.5)
    }
  },

  collapseMenuIcon: {
    fontSize: 20,
    margin: theme.spacing(0.5)
  }
}))
